import { render, staticRenderFns } from "./WordsModeInfoDialog.vue?vue&type=template&id=0d08aca7&"
import script from "./WordsModeInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./WordsModeInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports